import React from 'react'
import PropTypes from 'prop-types'
import { MyChip } from '@interstellar-component'

/**
 * The one chip of the Bulk Enquiry pages. Spread a constants entry into it:
 * `<StatusChip {...chipOf(BATCH_STATUS, code)} dot />`. Always the filled
 * variant: MyChip's 'modern' one draws every colour the same gray.
 */
export default function StatusChip({ label, color = 'gray', dot = false }) {
  return <MyChip label={label} color={color} variant="filled" size="sm" rounded="md" dot={dot} />
}

StatusChip.propTypes = {
  label: PropTypes.node.isRequired,
  color: PropTypes.string,
  dot: PropTypes.bool,
}
